export async function fetchProductData() {
    try {
        const response = await fetch("https://fakestoreapi.com/products");
        if (response.ok) {
            const data = await response.json();
            return data;
        }
        else {
            throw new Error("Product request failed");
        }
    }
    catch (error) {
        console.error(error);
        return [];
    }
}
export async function fetchProductDetails(id) {
    try {
        const response = await fetch(`https://fakestoreapi.com/products/${id}`);
        if (response.ok) {
            const data = await response.json();
            return data;
        }
        else {
            throw new Error("Product request failed");
        }
    }
    catch (error) {
        console.error(error);
        return null;
    }
}
export function getApiObject(data = null, isFetching = false, isUpdating = false, isError = false, errorMessage = "", error = null) {
    return { data, isFetching, isError, errorMessage, error, isUpdating };
}
